export default "__VITE_ASSET__tWKcQs5r__"